import { AppPlugins } from 'app/constants'
import listActionsByKey from 'app/listActionsByKey'
import ListAction from 'core/actions/ListAction'
import Plugin from 'core/plugins/plugin'
import { devEnabled } from 'core/utils/helpers'
import account from './account'
import developer from './developer'
import kubernetes from './kubernetes'
import opencloud from './opencloud'
import openstack from './openstack'

/** @warning if you add a plugin, make sure to add its corresponding feature flag */
const allPlugins = [
  // Order here is important as it will define the default Dashboard route
  // for fallback routes (when trying to reach the base url)
  // infrastructure,
  // kubernetes,
  // kubevirt,
  openstack,
  account,
  ...(devEnabled() ? [developer] : []),
]

// OpenCloud plugin is an extension of the OpenStack plugin. We cannot have both
// registered at the same time. This function replaces the OpenStack plugin with
// the OpenCloud plugin.
export const getOpenCloudPlugins = (allPlugins: Plugin[]) => {
  const openstackPluginIndex = allPlugins?.findIndex(
    (plugin) => plugin.pluginId === AppPlugins.OpenStack,
  )
  if (openstackPluginIndex !== -1) {
    return [
      ...allPlugins?.slice(0, openstackPluginIndex),
      opencloud,
      ...allPlugins?.slice(openstackPluginIndex + 1),
    ]
  }
  return []
}

// Load the ListActions here since they depend on ApiClient being initialized (on bootstrap.ts)
ListAction.initDependencies(listActionsByKey)

export default allPlugins
